import { WeatherLayer } from '@chr/online-shared-ui-maps';
import { useTrackingMap } from './TrackingMapProvider';
import { WeatherKey } from './WeatherKey';

export const TrackingMapWeatherLayer = () => {
    const { isWeatherEnabled } = useTrackingMap();

    return (
        <>
            <WeatherLayer enabled={isWeatherEnabled} data-testid="weather-layer" />
            <WeatherKey />
        </>
    );
}